export default __webpack_public_path__ + "static/media/right arrow_blue.b9486474.svg";